/* Bump when packaging. Shown in the header so it's obvious which build is
   running — the alternative is debugging a version nobody is actually using. */
export const VERSION = "v0.9.3 · 27 Jul 2026";
